import i18n from 'live/services/i18n'
import enUs from './en_us'
import ptBr from './pt_br'

export default ((): void => {
    const locale = window.Live.settings && window.Live.settings.locale ? window.Live.settings.locale : 'pt_br'
    const localeFiles = {
        pt_br: ptBr,
        en_us: enUs
    }

    i18n.add(localeFiles[locale])
})()
